// removed by extract-text-webpack-plugin
module.exports = {"empty":"SearchResults__empty--71hcZ","clipboard":"SearchResults__clipboard--WsG6l","content":"SearchResults__content--IfJ7n","bounce":"SearchResults__bounce--3YsR5"};


//////////////////
// WEBPACK FOOTER
// ./src/search/components/SearchResults/SearchResults.css
// module id = ./src/search/components/SearchResults/SearchResults.css
// module chunks = 1